import axios from 'axios'
import { useEffect, useState } from 'react'

async function getBannerAccess() {
  const result = await axios.get('https://crypto.com/cdn-cgi/trace')
  const matches = result.data.match(/loc=([A-Z]+)/)
  if (matches && matches[1] === 'US') {
    return false
  }
  return true
}

export const useRestrictedBanner = () => {
  const [isBannerRestricted, setBannerRestricted] = useState(true)
  useEffect(() => {
    const checkBannerAccess = async () => {
      const isBannerAccess = await getBannerAccess()
      setBannerRestricted(isBannerAccess)
    }
    checkBannerAccess()
  }, [])
  return isBannerRestricted
}
